import { FieldErrors, FieldValues, UseFormReturn, useFormContext } from 'react-hook-form';
import { ReactNode, useContext } from 'react';

import { FormContext } from '@/common/Form';

export type FormWatchProps = {
  name?: string | string[];
  defaultValue?: any;
  children: (value: unknown, form: UseFormReturn<FieldValues, any, undefined>) => ReactNode;
};

const FormWatch = ({ name, defaultValue, children }: FormWatchProps): ReactNode => {
  const form = useFormContext();
  const nameAsArray = (Array.isArray(name) ? name : [name]).filter(Boolean) as string[];
  const value = form.watch(nameAsArray.length > 0 ? nameAsArray : undefined, defaultValue);
  const {
    validatingFields: [validatingFields],
  } = useContext(FormContext);
  const [isValid, errors] = Object.entries({ ...form.formState.errors, ...form.control._formState.errors }).reduce(
    (acc: [boolean, FieldErrors<FieldValues>], [key, value]) => {
      if (validatingFields.has(key)) {
        return [acc[0] && value === undefined, { ...acc[1], [key]: value as FieldErrors<FieldValues>[string] }];
      }
      return acc;
    },
    [true, {} as FieldErrors<FieldValues>]
  );
  const formContext = { ...form, formState: { ...form.formState, isValid, validatingFields, errors } } as unknown as UseFormReturn<
    FieldValues,
    any,
    undefined
  >;
  return children(value, formContext);
};

export default FormWatch;
